// src/components/FloatingCart.js
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { CartContext } from "../utils/cartContext";
import { FaShoppingBasket } from "react-icons/fa";
import "../styles/floatingCart.css";

function FloatingCart() {
  const { cart } = useContext(CartContext);
  const cartItemCount = cart.length; // ✅ Get cart count
  const navigate = useNavigate();

  return (
    <div className="floating-cart" onClick={() => navigate("/cart")}>
      <FaShoppingBasket className="basket-icon" />
      {cartItemCount > 0 && <span className="cart-badge">{cartItemCount}</span>}
    </div>
  );
}

export default FloatingCart;
